import loadable from "@utils/loadable"
import LoadableLoading from "@components/Loading/LoadbleLoader"

export default loadable(() => import("./index"), {
  fallback: <LoadableLoading />,
})
